<div class="primary-bg container center" fxLayout="column" fxLayoutAlign="space-between center" fxLayoutGap="16px">
  <ng-container *ngIf="!!title; else loading">
    <div>
      <mat-icon [svgIcon]="svgIcon" class="status-icon">{{icon}}</mat-icon>
      <h1>
        {{title}}
      </h1>
      <p class="content" [innerHTML]="body"></p>
      <div class="description">
        <ul class="description__list" *ngIf="sickNote.fields.public_notes?.reasons || sickNote.extras?.status_reasons">
          <li class="description__item" *ngFor="let reason of reasons">
            <span>{{ reason }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <p class="content center">Seu protocolo é:</p>
      <h1>{{shortId}}</h1>
    </div>
  </ng-container>

  <div>
    <p class="content" [innerHTML]="messages?.after_send_notice"></p>
    <button mat-stroked-button class="closecare-button light" [routerLink]="['/a', shortId]">Ver detalhes do atestado</button>
  </div>
  <ng-template #loading>
    <mat-progress-spinner mode="indeterminate" color="accent" diameter="32"></mat-progress-spinner>
  </ng-template>
</div>
